import React from 'react';

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      &copy; {year} WeMotion Technology S.L. - <a href="http://wemotion.es">WeMotion.es</a>
    </footer>
  );
};
